import React from 'react';
import { Card, CardContent } from 'components/ui/card';

const NotAuthorizedError = (): JSX.Element => {
  return (
    <>
      <Card className="card-profile border-0 shadow-none">
        <CardContent className="bg-white border-0 text-center pt-6">
          <h2>Not Authorized</h2>
          <p className="pt-3 text-base font-normal leading-6 text-gray-blue-60">
            You do not have permissions to view this page.
          </p>
          <p className="text-base font-normal leading-6 text-gray-blue-60">
            Contact your team admin.
          </p>
        </CardContent>
      </Card>
    </>
  );
};

export default NotAuthorizedError;
